import { getState } from '~src/state';
import { displayBackgroundManager } from '~src/sidebar/index';

export const removeFormatBackgroundFromCache = (imageItemId, formatId) => {
  const currentFormat = getState(
    'sidebarCurrentBackgroundsFormat',
    'NO_FORMAT'
  );
  const backgroundItem = window.editorConfig.sidebarBackgrounds[
    currentFormat
  ].items.find((item) => item.objectId === imageItemId);

  backgroundItem.formats = backgroundItem.formats.filter(
    (format) => format.objectId !== formatId
  );

  displayBackgroundManager(imageItemId);
};
